module.exports = __webpack_public_path__ + "img/公众号.b3d29a43.jpg";